import { PAYMENT_SUCCESS } from 'containers/Checkout/actions'
import { STAGES, STAGE_SUCCESS } from 'containers/Checkout/constants'
import { SUBMIT_LEAD_SUCCESS } from 'containers/stages/SubmitStage/actions'
import { PERSONAL_SUBMIT_SUCCESS } from 'containers/stages/PersonalInfoStage/actions'
import { IDENTIFICATION_SUCCESS } from 'containers/stages/IdentificationStage/actions'
import { PLAN_SELECT_SUCCESS } from 'containers/stages/PlanSelectionStage/actions'
import { MODEM_DELIVERY_SUCCESS } from 'containers/stages/ModemStage/actions'
import gaEvent, { gaPageView } from 'utilities/tracking'

function buildItems(state) {
  const { planSelected } = state
  const items = [
    {
      id: planSelected.id,
      name: planSelected.title,
      price: planSelected.rate,
      quantity: 1,
    },
  ]
  return items
}

export default store => next => (action) => {
  const returnValue = next(action)
  if (!action) return returnValue

  const state = store.getState().checkoutReducer
  const newStageId = action.payload ? (action.payload.next || action.payload.nextStage || action.payload) : action

  switch (action.type) {
    case PLAN_SELECT_SUCCESS:
      gaEvent('begin_checkout', {
        items: buildItems(state),
        checkout_step: 1, // Modem delivery
      })
      if (newStageId) {
        gaPageView(newStageId)
      }
      break
    case PAYMENT_SUCCESS:
    case PERSONAL_SUBMIT_SUCCESS:
    case MODEM_DELIVERY_SUCCESS:
    case IDENTIFICATION_SUCCESS: {
      const stage = STAGES.find(s => s.id === newStageId)
      if (stage && stage.gaId) {
        gaEvent('checkout_progress', {
          checkout_step: stage.gaId,
          items: buildItems(state),
        })
      }
      gaPageView(newStageId)
      break
    }
    case SUBMIT_LEAD_SUCCESS:
      gaEvent('purchase', {
        transaction_id: action.payload.reference,
        value: state.planSelected.rate,
        currency: 'AUD',
        items: buildItems(state),
      })
      gaPageView(STAGE_SUCCESS)
      break
    default:
      break
  }

  return returnValue
}



// WEBPACK FOOTER //
// ./containers/Checkout/middleware.js